import React, { useEffect, useState, useRef } from 'react';
import {
    external1,
    //  account_step, account_step2, account_step3, account_step4,
    card_vector, carduser1, carduser2, carduser3, halfstar, onestart, start, arrowicon, mail, locicon,
    clients,
    workright,
} from '../../assets/images';
import { Accordion, Button, Card, Carousel, Modal, Container, Row, Col } from 'react-bootstrap';
import 'uikit/dist/css/uikit.min.css';
import 'uikit/dist/js/uikit.min.js';
import 'uikit/dist/js/uikit-icons.min.js'; // Optional if you want to use icons
import { useForm } from 'react-hook-form';
import axios from 'axios';
import { getContactApiUrl } from '../../config/api';
import { FaPlus, FaMinus } from "react-icons/fa";

const testimonials = [
    {
        title: 'Exceptional Service and Accuracy',
        quote: 'ProBill RCM has truly transformed our billing process. Their payment posting services are quick and accurate, and we’ve seen a significant improvement in our cash flow. The team is professional, responsive, and detail-oriented. Highly recommend!"– Dr. Sarah Thompson, Healthcare Clinic',
        name: "Wade Warren",
        role: "",
        rating: 4.3,
        img: carduser1, // You can replace this with actual images
    },
    {
        title: 'Efficient and Reliable',
        quote: "Working with ProBill RCM has been a game-changer for our practice. Their team handles everything from denial management to insurance payments seamlessly. Our revenue cycle has never been smoother, and their efficiency has saved us both time and money– John Myers, Practice Manager.",
        name: "Sophie Reynolds",
        role: "",
        rating: 4.2,
        img: carduser2,
    },
    {
        title: 'Outstanding Denials Management',
        quote: 'We struggled with managing claim denials before partnering with ProBill RCM. Their expertise in appeals and denial management has helped us recover significant revenue we would have otherwise lost. Excellent service all around!"– Lisa Perez, Medical Billing Specialist ',
        name: "David Mitchell",
        role: "",
        rating: 4.1,
        img: carduser3,
    },
    {
        title: 'Exceptional Service and Accuracy',
        quote: 'ProBill RCM has truly transformed our billing process. Their payment posting services are quick and accurate, and we’ve seen a significant improvement in our cash flow. The team is professional, responsive, and detail-oriented. Highly recommend!"– Dr. Sarah Thompson, Healthcare Clinic',
        name: "Wade Warren",
        role: "",
        rating: 4.3,
        img: carduser1, // You can replace this with actual images
    },
    {
        title: 'Efficient and Reliable',
        quote: "Working with ProBill RCM has been a game-changer for our practice. Their team handles everything from denial management to insurance payments seamlessly. Our revenue cycle has never been smoother, and their efficiency has saved us both time and money– John Myers, Practice Manager.",
        name: "Sophie Reynolds",
        role: "",
        rating: 4.2,
        img: carduser2,
    },
    {
        title: 'Outstanding Denials Management',
        quote: 'We struggled with managing claim denials before partnering with ProBill RCM. Their expertise in appeals and denial management has helped us recover significant revenue we would have otherwise lost. Excellent service all around!"– Lisa Perez, Medical Billing Specialist ',
        name: "David Mitchell",
        role: "",
        rating: 4.1,
        img: carduser3,
    },
    {
        title: 'Exceptional Service and Accuracy',
        quote: 'ProBill RCM has truly transformed our billing process. Their payment posting services are quick and accurate, and we’ve seen a significant improvement in our cash flow. The team is professional, responsive, and detail-oriented. Highly recommend!"– Dr. Sarah Thompson, Healthcare Clinic',
        name: "Wade Warren",
        role: "",
        rating: 4.3,
        img: carduser1, // You can replace this with actual images
    },
    {
        title: 'Efficient and Reliable',
        quote: "Working with ProBill RCM has been a game-changer for our practice. Their team handles everything from denial management to insurance payments seamlessly. Our revenue cycle has never been smoother, and their efficiency has saved us both time and money– John Myers, Practice Manager.",
        name: "Sophie Reynolds",
        role: "",
        rating: 4.2,
        img: carduser2,
    },
    {
        title: 'Outstanding Denials Management',
        quote: 'We struggled with managing claim denials before partnering with ProBill RCM. Their expertise in appeals and denial management has helped us recover significant revenue we would have otherwise lost. Excellent service all around!"– Lisa Perez, Medical Billing Specialist ',
        name: "David Mitchell",
        role: "",
        rating: 4.1,
        img: carduser3,
    },
    {
        title: 'Exceptional Service and Accuracy',
        quote: 'ProBill RCM has truly transformed our billing process. Their payment posting services are quick and accurate, and we’ve seen a significant improvement in our cash flow. The team is professional, responsive, and detail-oriented. Highly recommend!"– Dr. Sarah Thompson, Healthcare Clinic',
        name: "Wade Warren",
        role: "",
        rating: 4.3,
        img: carduser1, // You can replace this with actual images
    },
    {
        title: 'Efficient and Reliable',
        quote: "Working with ProBill RCM has been a game-changer for our practice. Their team handles everything from denial management to insurance payments seamlessly. Our revenue cycle has never been smoother, and their efficiency has saved us both time and money– John Myers, Practice Manager.",
        name: "Sophie Reynolds",
        role: "",
        rating: 4.2,
        img: carduser2,
    },
    {
        title: 'Outstanding Denials Management',
        quote: 'We struggled with managing claim denials before partnering with ProBill RCM. Their expertise in appeals and denial management has helped us recover significant revenue we would have otherwise lost. Excellent service all around!"– Lisa Perez, Medical Billing Specialist ',
        name: "David Mitchell",
        role: "",
        rating: 4.1,
        img: carduser3,
    },
    {
        title: 'Exceptional Service and Accuracy',
        quote: 'ProBill RCM has truly transformed our billing process. Their payment posting services are quick and accurate, and we’ve seen a significant improvement in our cash flow. The team is professional, responsive, and detail-oriented. Highly recommend!"– Dr. Sarah Thompson, Healthcare Clinic',
        name: "Wade Warren",
        role: "",
        rating: 4.3,
        img: carduser1, // You can replace this with actual images
    },
    {
        title: 'Efficient and Reliable',
        quote: "Working with ProBill RCM has been a game-changer for our practice. Their team handles everything from denial management to insurance payments seamlessly. Our revenue cycle has never been smoother, and their efficiency has saved us both time and money– John Myers, Practice Manager.",
        name: "Sophie Reynolds",
        role: "",
        rating: 4.2,
        img: carduser2,
    },
    {
        title: 'Outstanding Denials Management',
        quote: 'We struggled with managing claim denials before partnering with ProBill RCM. Their expertise in appeals and denial management has helped us recover significant revenue we would have otherwise lost. Excellent service all around!"– Lisa Perez, Medical Billing Specialist ',
        name: "David Mitchell",
        role: "",
        rating: 4.1,
        img: carduser3,
    },
    {
        title: 'Exceptional Service and Accuracy',
        quote: 'ProBill RCM has truly transformed our billing process. Their payment posting services are quick and accurate, and we’ve seen a significant improvement in our cash flow. The team is professional, responsive, and detail-oriented. Highly recommend!"– Dr. Sarah Thompson, Healthcare Clinic',
        name: "Wade Warren",
        role: "",
        rating: 4.3,
        img: carduser1, // You can replace this with actual images
    },
    {
        title: 'Efficient and Reliable',
        quote: "Working with ProBill RCM has been a game-changer for our practice. Their team handles everything from denial management to insurance payments seamlessly. Our revenue cycle has never been smoother, and their efficiency has saved us both time and money– John Myers, Practice Manager.",
        name: "Sophie Reynolds",
        role: "",
        rating: 4.2,
        img: carduser2,
    },
    {
        title: 'Outstanding Denials Management',
        quote: 'We struggled with managing claim denials before partnering with ProBill RCM. Their expertise in appeals and denial management has helped us recover significant revenue we would have otherwise lost. Excellent service all around!"– Lisa Perez, Medical Billing Specialist ',
        name: "David Mitchell",
        role: "",
        rating: 4.1,
        img: carduser3,
    },
    {
        title: 'Exceptional Service and Accuracy',
        quote: 'ProBill RCM has truly transformed our billing process. Their payment posting services are quick and accurate, and we’ve seen a significant improvement in our cash flow. The team is professional, responsive, and detail-oriented. Highly recommend!"– Dr. Sarah Thompson, Healthcare Clinic',
        name: "Wade Warren",
        role: "",
        rating: 4.3,
        img: carduser1, // You can replace this with actual images
    },
    {
        title: 'Efficient and Reliable',
        quote: "Working with ProBill RCM has been a game-changer for our practice. Their team handles everything from denial management to insurance payments seamlessly. Our revenue cycle has never been smoother, and their efficiency has saved us both time and money– John Myers, Practice Manager.",
        name: "Sophie Reynolds",
        role: "",
        rating: 4.2,
        img: carduser2,
    },
    {
        title: 'Outstanding Denials Management',
        quote: 'We struggled with managing claim denials before partnering with ProBill RCM. Their expertise in appeals and denial management has helped us recover significant revenue we would have otherwise lost. Excellent service all around!"– Lisa Perez, Medical Billing Specialist ',
        name: "David Mitchell",
        role: "",
        rating: 4.1,
        img: carduser3,
    },
    {
        title: 'Exceptional Service and Accuracy',
        quote: 'ProBill RCM has truly transformed our billing process. Their payment posting services are quick and accurate, and we’ve seen a significant improvement in our cash flow. The team is professional, responsive, and detail-oriented. Highly recommend!"– Dr. Sarah Thompson, Healthcare Clinic',
        name: "Wade Warren",
        role: "",
        rating: 4.3,
        img: carduser1, // You can replace this with actual images
    },
    {
        title: 'Efficient and Reliable',
        quote: "Working with ProBill RCM has been a game-changer for our practice. Their team handles everything from denial management to insurance payments seamlessly. Our revenue cycle has never been smoother, and their efficiency has saved us both time and money– John Myers, Practice Manager.",
        name: "Sophie Reynolds",
        role: "",
        rating: 4.2,
        img: carduser2,
    },
    {
        title: 'Outstanding Denials Management',
        quote: 'We struggled with managing claim denials before partnering with ProBill RCM. Their expertise in appeals and denial management has helped us recover significant revenue we would have otherwise lost. Excellent service all around!"– Lisa Perez, Medical Billing Specialist ',
        name: "David Mitchell",
        role: "",
        rating: 4.1,
        img: carduser3,
    },
    {
        title: 'Exceptional Service and Accuracy',
        quote: 'ProBill RCM has truly transformed our billing process. Their payment posting services are quick and accurate, and we’ve seen a significant improvement in our cash flow. The team is professional, responsive, and detail-oriented. Highly recommend!"– Dr. Sarah Thompson, Healthcare Clinic',
        name: "Wade Warren",
        role: "",
        rating: 4.3,
        img: carduser1, // You can replace this with actual images
    },
    {
        title: 'Efficient and Reliable',
        quote: "Working with ProBill RCM has been a game-changer for our practice. Their team handles everything from denial management to insurance payments seamlessly. Our revenue cycle has never been smoother, and their efficiency has saved us both time and money– John Myers, Practice Manager.",
        name: "Sophie Reynolds",
        role: "",
        rating: 4.2,
        img: carduser2,
    },
    {
        title: 'Outstanding Denials Management',
        quote: 'We struggled with managing claim denials before partnering with ProBill RCM. Their expertise in appeals and denial management has helped us recover significant revenue we would have otherwise lost. Excellent service all around!"– Lisa Perez, Medical Billing Specialist ',
        name: "David Mitchell",
        role: "",
        rating: 4.1,
        img: carduser3,
    },
    {
        title: 'Exceptional Service and Accuracy',
        quote: 'ProBill RCM has truly transformed our billing process. Their payment posting services are quick and accurate, and we’ve seen a significant improvement in our cash flow. The team is professional, responsive, and detail-oriented. Highly recommend!"– Dr. Sarah Thompson, Healthcare Clinic',
        name: "Wade Warren",
        role: "",
        rating: 4.3,
        img: carduser1, // You can replace this with actual images
    },
    {
        title: 'Efficient and Reliable',
        quote: "Working with ProBill RCM has been a game-changer for our practice. Their team handles everything from denial management to insurance payments seamlessly. Our revenue cycle has never been smoother, and their efficiency has saved us both time and money– John Myers, Practice Manager.",
        name: "Sophie Reynolds",
        role: "",
        rating: 4.2,
        img: carduser2,
    },
    {
        title: 'Outstanding Denials Management',
        quote: 'We struggled with managing claim denials before partnering with ProBill RCM. Their expertise in appeals and denial management has helped us recover significant revenue we would have otherwise lost. Excellent service all around!"– Lisa Perez, Medical Billing Specialist ',
        name: "David Mitchell",
        role: "",
        rating: 4.1,
        img: carduser3,
    },
    {
        title: 'Exceptional Service and Accuracy',
        quote: 'ProBill RCM has truly transformed our billing process. Their payment posting services are quick and accurate, and we’ve seen a significant improvement in our cash flow. The team is professional, responsive, and detail-oriented. Highly recommend!"– Dr. Sarah Thompson, Healthcare Clinic',
        name: "Wade Warren",
        role: "",
        rating: 4.3,
        img: carduser1, // You can replace this with actual images
    },
    {
        title: 'Efficient and Reliable',
        quote: "Working with ProBill RCM has been a game-changer for our practice. Their team handles everything from denial management to insurance payments seamlessly. Our revenue cycle has never been smoother, and their efficiency has saved us both time and money– John Myers, Practice Manager.",
        name: "Sophie Reynolds",
        role: "",
        rating: 4.2,
        img: carduser2,
    },
    {
        title: 'Outstanding Denials Management',
        quote: 'We struggled with managing claim denials before partnering with ProBill RCM. Their expertise in appeals and denial management has helped us recover significant revenue we would have otherwise lost. Excellent service all around!"– Lisa Perez, Medical Billing Specialist ',
        name: "David Mitchell",
        role: "",
        rating: 4.1,
        img: carduser3,
    },
    {
        title: 'Exceptional Service and Accuracy',
        quote: 'ProBill RCM has truly transformed our billing process. Their payment posting services are quick and accurate, and we’ve seen a significant improvement in our cash flow. The team is professional, responsive, and detail-oriented. Highly recommend!"– Dr. Sarah Thompson, Healthcare Clinic',
        name: "Wade Warren",
        role: "",
        rating: 4.3,
        img: carduser1, // You can replace this with actual images
    },
    {
        title: 'Efficient and Reliable',
        quote: "Working with ProBill RCM has been a game-changer for our practice. Their team handles everything from denial management to insurance payments seamlessly. Our revenue cycle has never been smoother, and their efficiency has saved us both time and money– John Myers, Practice Manager.",
        name: "Sophie Reynolds",
        role: "",
        rating: 4.2,
        img: carduser2,
    },
    {
        title: 'Outstanding Denials Management',
        quote: 'We struggled with managing claim denials before partnering with ProBill RCM. Their expertise in appeals and denial management has helped us recover significant revenue we would have otherwise lost. Excellent service all around!"– Lisa Perez, Medical Billing Specialist ',
        name: "David Mitchell",
        role: "",
        rating: 4.1,
        img: carduser3,
    },
    {
        title: 'Exceptional Service and Accuracy',
        quote: 'ProBill RCM has truly transformed our billing process. Their payment posting services are quick and accurate, and we’ve seen a significant improvement in our cash flow. The team is professional, responsive, and detail-oriented. Highly recommend!"– Dr. Sarah Thompson, Healthcare Clinic',
        name: "Wade Warren",
        role: "",
        rating: 4.3,
        img: carduser1, // You can replace this with actual images
    },
    {
        title: 'Efficient and Reliable',
        quote: "Working with ProBill RCM has been a game-changer for our practice. Their team handles everything from denial management to insurance payments seamlessly. Our revenue cycle has never been smoother, and their efficiency has saved us both time and money– John Myers, Practice Manager.",
        name: "Sophie Reynolds",
        role: "",
        rating: 4.2,
        img: carduser2,
    },
    {
        title: 'Outstanding Denials Management',
        quote: 'We struggled with managing claim denials before partnering with ProBill RCM. Their expertise in appeals and denial management has helped us recover significant revenue we would have otherwise lost. Excellent service all around!"– Lisa Perez, Medical Billing Specialist ',
        name: "David Mitchell",
        role: "",
        rating: 4.1,
        img: carduser3,
    },
    {
        title: 'Exceptional Service and Accuracy',
        quote: 'ProBill RCM has truly transformed our billing process. Their payment posting services are quick and accurate, and we’ve seen a significant improvement in our cash flow. The team is professional, responsive, and detail-oriented. Highly recommend!"– Dr. Sarah Thompson, Healthcare Clinic',
        name: "Wade Warren",
        role: "",
        rating: 4.3,
        img: carduser1, // You can replace this with actual images
    },
    {
        title: 'Efficient and Reliable',
        quote: "Working with ProBill RCM has been a game-changer for our practice. Their team handles everything from denial management to insurance payments seamlessly. Our revenue cycle has never been smoother, and their efficiency has saved us both time and money– John Myers, Practice Manager.",
        name: "Sophie Reynolds",
        role: "",
        rating: 4.2,
        img: carduser2,
    },
    {
        title: 'Outstanding Denials Management',
        quote: 'We struggled with managing claim denials before partnering with ProBill RCM. Their expertise in appeals and denial management has helped us recover significant revenue we would have otherwise lost. Excellent service all around!"– Lisa Perez, Medical Billing Specialist ',
        name: "David Mitchell",
        role: "",
        rating: 4.1,
        img: carduser3,
    },
    {
        title: 'Exceptional Service and Accuracy',
        quote: 'ProBill RCM has truly transformed our billing process. Their payment posting services are quick and accurate, and we’ve seen a significant improvement in our cash flow. The team is professional, responsive, and detail-oriented. Highly recommend!"– Dr. Sarah Thompson, Healthcare Clinic',
        name: "Wade Warren",
        role: "",
        rating: 4.3,
        img: carduser1, // You can replace this with actual images
    },
    {
        title: 'Efficient and Reliable',
        quote: "Working with ProBill RCM has been a game-changer for our practice. Their team handles everything from denial management to insurance payments seamlessly. Our revenue cycle has never been smoother, and their efficiency has saved us both time and money– John Myers, Practice Manager.",
        name: "Sophie Reynolds",
        role: "",
        rating: 4.2,
        img: carduser2,
    },
    {
        title: 'Outstanding Denials Management',
        quote: 'We struggled with managing claim denials before partnering with ProBill RCM. Their expertise in appeals and denial management has helped us recover significant revenue we would have otherwise lost. Excellent service all around!"– Lisa Perez, Medical Billing Specialist ',
        name: "David Mitchell",
        role: "",
        rating: 4.1,
        img: carduser3,
    },
];

const ContactUs = () => {
    const sectionRefs = useRef([]);
    const containerRef = useRef();

    const [animatedSections, setAnimatedSections] = useState(new Set());
    const [hasAnimated, setHasAnimated] = useState(new Set());
    const CARD_WIDTH =
        window.innerWidth < 768
            ? 335
            : window.innerWidth < 1024
                ? 350
                : window.innerWidth < 1200
                    ? 400
                    : window.innerWidth < 1500
                        ? 450
                        : window.innerWidth < 1700
                            ? 500
                            : window.innerWidth < 1800
                                ? 568
                                : 625;
    const infiniteTestimonials = [...testimonials, ...testimonials, ...testimonials];

    const groupedTestimonials = [];
    for (let i = 0; i < testimonials.length; i += 3) {
        groupedTestimonials.push(testimonials.slice(i, i + 3));
    }

    const [currentIndex, setCurrentIndex] = useState(0);
    const [visibleCards, setVisibleCards] = useState(3.5);

    const updateVisibleCards = () => {
        setVisibleCards(3);
    };

    const [activeKey, setActiveKey] = useState("0");

    const toggleKey = (key) => {
        setActiveKey(activeKey === key ? null : key);
    };
    useEffect(() => {
        updateVisibleCards();
        window.addEventListener('resize', updateVisibleCards);

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    const index = entry.target.dataset.sectionIndex;
                    if (index) {
                        const sectionIndex = parseInt(index);
                        if (entry.isIntersecting && !hasAnimated.has(sectionIndex)) {
                            setAnimatedSections(prev => new Set([...prev, sectionIndex]));
                            setHasAnimated(prev => new Set([...prev, sectionIndex]));
                        }
                    }
                });
            },
            { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
        );

        sectionRefs.current.forEach((ref) => {
            if (ref) observer.observe(ref);
        });

        return () => {
            window.removeEventListener('resize', updateVisibleCards);
            observer.disconnect();
        };
    }, []);

    const handleNext = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex < testimonials.length - visibleCards ? prevIndex + 1 : prevIndex
        );
    };

    const handlePrev = () => {
        setCurrentIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : prevIndex));
    };
    const [showModal, setShowModal] = useState(false);
    const handleClose = () => {
        setShowModal(false);
        setIsSubmitted(false);
        setSubmitStatus(null);
    };
    const handleShow = () => setShowModal(true);
    const [activeAccordion, setActiveAccordion] = useState(null);
    const handleAccordionToggle = (eventKey) => {
        setActiveAccordion(prev => (prev === eventKey ? null : eventKey));
    }
    // const getImageToShow = () => {
    //     switch (activeAccordion) {
    //         case "0":
    //             return account_step2;
    //         case "1":
    //             return account_step3;
    //         case "2":
    //             return account_step4;
    //         case "3":
    //             return account_step5;
    //         default:
    //             return account_step;
    //     }
    // };



    const [navbarColor, setNavbarColor] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);


    useEffect(() => {
        window.scrollTo(0, 0);

        const changeNavbarColor = () => {
            if (window.scrollY >= 80) {
                setNavbarColor(true);
            } else {
                setNavbarColor(false);
            }
        };
        window.addEventListener('scroll', changeNavbarColor);
        return () => {
            window.removeEventListener('scroll', changeNavbarColor);
        };
    }, []);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitStatus, setSubmitStatus] = useState(null);
    const [isAutoPlaying, setIsAutoPlaying] = useState(true);

    const {
        register,
        handleSubmit,
        formState: { errors },
        reset
    } = useForm();

    const onSubmit = async (data) => {
        setIsSubmitting(true);
        setSubmitStatus(null);

        try {
            const response = await axios.post(getContactApiUrl(), {
                fullName: data.fullName,
                email: data.email,
                subject: data.subject || 'Contact Form Submission',
                message: data.message,
            });

            if (response.data.success) {
                setSubmitStatus('success');
                setIsSubmitted(true);
                reset();
            } else {
                setSubmitStatus('error');
            }
        } catch (error) {
            console.error("Error sending email: ", error);
            setSubmitStatus('error');
        } finally {
            setIsSubmitting(false);
        }
    };
    useEffect(() => {
        if (!isAutoPlaying) return;

        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) => {
                const maxIndex = testimonials.length - Math.floor(visibleCards);
                return prevIndex >= maxIndex ? 0 : prevIndex + 1;
            });
        }, 2500); // Change slide every 3 seconds

        return () => clearInterval(interval);
    }, [isAutoPlaying, visibleCards]);
    return (
        <>
            <style>{`
                @media (min-width: 768px) {
                    .animate-section[data-section-index="0"] {
                        opacity: 0;
                        transform: translateY(80px) scale(0.9);
                        transition: all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
                    }
                    .animate-section[data-section-index="0"].visible {
                        opacity: 1 !important;
                        transform: translateY(0) scale(1) !important;
                    }
                    .animate-section[data-section-index="1"] {
                        opacity: 0;
                        transform: translateX(-60px) rotateY(10deg);
                        transition: all 0.7s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.2s;
                    }
                    .animate-section[data-section-index="1"].visible {
                        opacity: 1 !important;
                        transform: translateX(0) rotateY(0deg) !important;
                    }
                    .animate-section[data-section-index="2"] {
                        opacity: 0;
                        transform: translateY(60px) scale(0.95);
                        transition: all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.3s;
                    }
                    .animate-section[data-section-index="2"].visible {
                        opacity: 1 !important;
                        transform: translateY(0) scale(1) !important;
                    }
                    .animate-section[data-section-index="3"] {
                        opacity: 0;
                        transform: translateY(70px) scale(0.9);
                        transition: all 0.7s ease-in-out 0.4s;
                    }
                    .animate-section[data-section-index="3"].visible {
                        opacity: 1 !important;
                        transform: translateY(0) scale(1) !important;
                    }
                    .animate-section[data-section-index="4"] {
                        opacity: 0;
                        transform: translateX(50px) rotateY(-5deg);
                        transition: all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.5s;
                    }
                    .animate-section[data-section-index="4"].visible {
                        opacity: 1 !important;
                        transform: translateX(0) rotateY(0deg) !important;
                    }
                    .animate-section[data-section-index="5"] {
                        opacity: 0;
                        transform: translateY(50px) scale(0.95);
                        transition: all 0.5s ease-out 0.6s;
                    }
                    .animate-section[data-section-index="5"].visible {
                        opacity: 1 !important;
                        transform: translateY(0) scale(1) !important;
                    }
                    .animate-section[data-section-index="6"] {
                        opacity: 0;
                        transform: translateY(40px) scale(0.98);
                        transition: all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.7s;
                    }
                    .animate-section[data-section-index="6"].visible {
                        opacity: 1 !important;
                        transform: translateY(0) scale(1) !important;
                    }
                }
                @media (max-width: 767px) {
                    .animate-section[data-section-index="0"] {
                        opacity: 0;
                        transform: translateY(20px);
                        transition: all 0.6s ease;
                    }
                    .animate-section[data-section-index="0"].visible {
                        opacity: 1 !important;
                        transform: translateY(0) !important;
                    }
                    .animate-section[data-section-index="1"] {
                        opacity: 0;
                        transform: translateY(20px);
                        transition: all 0.6s ease 0.1s;
                    }
                    .animate-section[data-section-index="1"].visible {
                        opacity: 1 !important;
                        transform: translateY(0) !important;
                    }
                    .animate-section[data-section-index="2"] {
                        opacity: 0;
                        transform: translateY(20px);
                        transition: all 0.6s ease 0.2s;
                    }
                    .animate-section[data-section-index="2"].visible {
                        opacity: 1 !important;
                        transform: translateY(0) !important;
                    }
                    .animate-section[data-section-index="3"] {
                        opacity: 0;
                        transform: translateY(20px);
                        transition: all 0.6s ease 0.3s;
                    }
                    .animate-section[data-section-index="3"].visible {
                        opacity: 1 !important;
                        transform: translateY(0) !important;
                    }
                    .animate-section[data-section-index="4"] {
                        opacity: 0;
                        transform: translateY(20px);
                        transition: all 0.6s ease 0.4s;
                    }
                    .animate-section[data-section-index="4"].visible {
                        opacity: 1 !important;
                        transform: translateY(0) !important;
                    }
                    .animate-section[data-section-index="5"] {
                        opacity: 0;
                        transform: translateY(20px);
                        transition: all 0.6s ease 0.5s;
                    }
                    .animate-section[data-section-index="5"].visible {
                        opacity: 1 !important;
                        transform: translateY(0) !important;
                    }
                    .animate-section[data-section-index="6"] {
                        opacity: 0;
                        transform: translateY(20px);
                        transition: all 0.6s ease 0.6s;
                    }
                    .animate-section[data-section-index="6"].visible {
                        opacity: 1 !important;
                        transform: translateY(0) !important;
                    }
                }
                .contact-btn {
                    transition: all 0.3s ease;
                    transform: translateY(0);
                }
                .contact-btn:hover {
                    transform: translateY(-3px);
                    box-shadow: 0 10px 30px rgba(226, 114, 57, 0.4);
                }
                .form-control {
                    transition: all 0.3s ease;
                }
                .form-control:focus {
                    transform: translateY(-2px);
                    box-shadow: 0 5px 15px rgba(226, 114, 57, 0.2);
                    border-color: #E27239;
                }
                .need-help {
                    transition: all 0.3s ease;
                }
                .need-help:hover {
                    transform: translateY(-5px);
                    box-shadow: 0 15px 35px rgba(0,0,0,0.1);
                }
            `}</style>
            <section className="hero-section text-center">
                <div
                    className={`d-flex align-items-center justify-content-center animate-section small_size ${animatedSections.has(0) ? 'visible' : ''}`}
                    ref={el => sectionRefs.current[0] = el}
                    data-section-index="0"
                >
                    <div className="row mx-auto mt-lg-5 mt-5">
                        <div className="col-12 text-center mt-md-4 mt-0">
                            <h1 className="about_font text-white fw-bold" >
                                <span className="text-orange">Contact</span> Us
                            </h1>
                            <p className='mb-0 text-white add_para_font fw-medium'>
                                Let’s turn your billing challenges into smart solutions start the conversation today.

                            </p>
                        </div>
                    </div>
                </div>
                <div
                    className={`container mb-md-5 mb-4 mt-lg-5 pt-4 pt-md-4 animate-section ${animatedSections.has(1) ? 'visible' : ''}`}
                    ref={el => sectionRefs.current[1] = el}
                    data-section-index="1"
                >
                    <div className="row d-flex justify-content-center mx-auto">
                        <div className="col-lg-6  pe-5 d-none d-md-block">
                            <div className="image-container">
                                <img
                                    src={external1}
                                    alt="Team Working"
                                    className="w-100 h-100 diagonal-image"
                                />
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-12 ps-md-5 px-0 mt-0 mt-md-0">
                            <div className='row mx-auto'>
                                <div className='col-12 d-md-flex d-none align-items-center justify-content-start mb-md-2'>
                                    <p className='mb-0 d-flex align-items-center justify-content-start'>
                                        <img src={arrowicon} alt='revenue cycle management' className='add_width_arrow me-3' /> <span className='add_grident_font add_font_another'>
                                            Contact Us                                    </span>
                                    </p>
                                </div>
                                <div className='col-12 d-flex align-items-center justify-content-start'>
                                    <h4 className='mb-0 d-flex align-items-center justify-content-start add_font_head fw-semibold'>
                                        Reach & Get In Touch With Us                                </h4>
                                </div>
                            </div>

                            {/* Status Messages */}
                            {submitStatus === 'success' && (
                                <div className="alert alert-success mt-3" role="alert">
                                    Thank you! Your message has been sent successfully. We'll get back to you within 24 hours.
                                </div>
                            )}

                            {submitStatus === 'error' && (
                                <div className="alert alert-danger mt-3" role="alert">
                                    Sorry! There was an error sending your message. Please try again or contact us directly.
                                </div>
                            )}

                            <form onSubmit={handleSubmit(onSubmit)} className="mt-md-4 mt-3">
                                <div className="row mx-auto">
                                    <div className="col-md-6 mb-3">
                                        <label className="form-label fw-medium text-start d-block">Name</label>
                                        <input
                                            type="text"
                                            placeholder="Enter your Full Name"
                                            className={`custom_control py-2 form-control ${errors.fullName ? "is-invalid" : ""}`}
                                            style={{ border: "1px solid #A4A4A480", height: "55px" }}
                                            {...register("fullName", { required: "Full Name is required" })}
                                        />
                                        {errors.fullName && (
                                            <p className="text-danger">{errors.fullName.message}</p>
                                        )}
                                    </div>

                                    <div className="col-md-6 mb-3">
                                        <label className="form-label fw-medium text-start d-block">Email</label>
                                        <input
                                            type="email"
                                            placeholder="Enter your Email"
                                            className={`custom_control py-2 form-control ${errors.email ? "is-invalid" : ""}`}
                                            style={{ border: "1px solid #A4A4A480", height: "55px" }}
                                            {...register("email", {
                                                required: "Email is required",
                                                pattern: {
                                                    value: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
                                                    message: "Please enter a valid email address"
                                                }
                                            })}
                                        />
                                        {errors.email && (
                                            <p className="text-danger">{errors.email.message}</p>
                                        )}
                                    </div>

                                    <div className="col-md-12 mb-3">
                                        <label className="form-label fw-medium text-start d-block">Subject</label>
                                        <input
                                            type="text"
                                            placeholder="Enter Subject"
                                            className={`custom_control py-2 form-control ${errors.subject ? "is-invalid" : ""}`}
                                            style={{ border: "1px solid #A4A4A480", height: "55px" }}
                                            {...register("subject", {
                                                required: "Subject is required",
                                                minLength: {
                                                    value: 3,
                                                    message: "Subject should be at least 3 characters long"
                                                }
                                            })}
                                        />
                                        {errors.subject && (
                                            <p className="text-danger">{errors.subject.message}</p>
                                        )}
                                    </div>

                                    <div className="col-md-12 mb-3">
                                        <label className="form-label fw-medium text-start d-block">Message</label>
                                        <textarea
                                            className={`custom_control py-2 form-control ${errors.message ? "is-invalid" : ""}`}
                                            style={{ border: "1px solid #A4A4A480" }}
                                            rows="7"
                                            placeholder="Brief us on your requirements"
                                            {...register("message", {
                                                required: "Message is required",
                                                minLength: {
                                                    value: 10,
                                                    message: "Message should be at least 10 characters long"
                                                }
                                            })}
                                        ></textarea>
                                        {errors.message && (
                                            <p className="text-danger">{errors.message.message}</p>
                                        )}
                                    </div>

                                    <div className="col-md-12 mt-md-3 mt-0">
                                        <button
                                            type="submit"
                                            className="btn col-12"
                                            style={{
                                                background: "linear-gradient(to right, #F37016 0%, #B1510F 100%)",
                                                color: "white",
                                                borderRadius: "12px",
                                                padding: "12px 24px",
                                                border: "none",
                                                fontWeight: "500",
                                                fontSize: "16px"
                                            }}
                                            disabled={isSubmitting}
                                        >
                                            {isSubmitting ? "SENDING..." : "Submit Now"}
                                        </button>
                                        {/* <p className="fs-6 mt-2" style={{ color: "#2A3040" }}>
                                        Within 24 hours, a representative from our company will contact you.
                                    </p> */}
                                    </div>
                                </div>
                            </form>




                        </div>


                    </div>
                </div>
                <div
                    className={`position-relative animate-section ${animatedSections.has(2) ? 'visible' : ''}`}
                    ref={el => sectionRefs.current[2] = el}
                    data-section-index="2"
                >
                    <Container>
                        <Row className='mb-3 mt-0  mb-md-5 mt-md-5 pt-md-4 pt-0 mx-auto'>
                            <Col xs={12} md={6} lg={6} className=''>
                                <div className="div d-flex need-help py-4" style={{ backgroundColor: '#2A3040', borderRadius: '8px' }}>
                                    <img src="https://bmgweb.s3.us-east-1.amazonaws.com/assets/help-icon1.png" className='mx-md-5 mx-2 img-fluid help-img my-auto d-md-block d-none' alt="" />
                                    <div className="d-flex  align-items-center justify-content-center justify-content-md-start col-12">
                                        <img src="https://bmgweb.s3.us-east-1.amazonaws.com/assets/help-icon2.png" className=' img-fluid help-img' alt="" style={{ height: "4.5rem" }} />
                                        <div className="slider-card-heading text-white px-md-3 pe-0 ps-3 mt-0 mt-md-0 text-start ">
                                            <h1 className='text-white fw-bold mb-md-3 mb-1' style={{ fontSize: "36px", lineHeight: "auto" }}>Need Any Help?</h1>
                                            <p className='fw-medium mt-0 mb-0 add_font_small_data_text' style={{ fontSize: "18px", lineHeight: "auto" }}>We are here to help you with any question</p>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                            <Col xs={12} md={6} lg={6} className=' mt-4 mt-md-0'>
                                <div className=" need-help border d-flex align-items-center justify-content-start py-md-4 py-3 px-4 " style={{ borderRadius: '8px' }}>
                                    <div className="row ps-md-3 ps-0 mx-auto">
                                        <div className="col-12  ">
                                            <div className="d-flex">
                                                <div className="slider-card-headin  ">

                                                    <div className="d-flex align-items-center p-0 mb-md-3 mb-2">
                                                        <div className="d-flex align-items-center gap-1 ">
                                                            <img src={mail} alt='' style={{ width: "30px", height: "26px" }} />
                                                        </div>

                                                        <h5 className="item-detail-img-heading  px-2 mt-0 mb-0 fw-semibold ps-md-4 ps-3 add_font_small_data_text" style={{ fontSize: "20px", lineHeight: "auto" }}>
                                                            hello@probillrcm.com
                                                        </h5>

                                                    </div>
                                                    <div className="d-flex align-items-center p-0">
                                                        <div className="d-flex align-items-center gap-1 pe-1 ps-1 ">
                                                            <img src={locicon} alt='' style={{ width: "25px", height: "35px" }} />
                                                        </div>

                                                        <h5 className="item-detail-img-heading  px-2 mt-0 mb-0 fw-semibold ps-md-4 ps-3 text-start add_font_small_data_text" style={{ fontSize: "20px", lineHeight: "auto" }}>
                                                            30799 Pinetree Rd#432,Pepper Pike,OH 44124                                                </h5>


                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>



                            </Col>
                        </Row>
                    </Container>
                    <div class="boost_main_client_right boost_main_client_right_tranform_contact position-absolute"><img src={workright} alt="" /></div>

                </div>
                <div
                    className={`container mt-lg-0 mt-0 card-bg-vector animate-section ${animatedSections.has(3) ? 'visible' : ''}`}
                    ref={el => sectionRefs.current[3] = el}
                    data-section-index="3"
                >
                    <div className="row mx-auto">
                        <div className="col-lg-8 col-12 m-0 mt-lg-4 text-start">
                            <h2 className=" text-dark text-probill-rcm m-0 mt-lg-0 mt-2 ">Our Positive  <span className="text-probill-rcm-orange">Social Impact</span></h2>
                            <p className='mt-lg-3 mt-0 text-probill-para m-0 mb-3 mb-md-0 '>Trusted by Healthcare Professionals</p>
                        </div>
                        <div className="col-lg-4 mt-lg-4 col-12 text-lg-end text-center">
                            {/* <h5 className='me-0 fw-semibold mb-2' style={{ fontSize: "24px", lineHeight: "40px" }}><img src={onestart} alt="" style={{ width: "27px", height: "27px" }} /> Trustpilot</h5> */}
                            <div className="d-flex justify-content-lg-end justify-content-center align-items-end">
                                <div className="d-flex justify-content-between ">

                                    <div className="div star mx-1 d-flex align-item-center ">
                                        <img src={start} className='mx-auto img-fluid' alt="" />
                                    </div>
                                    <div className="div star mx-1 d-flex align-item-center">
                                        <img src={start} className='mx-auto img-fluid' alt="" />
                                    </div>
                                    <div className="div star mx-1 d-flex align-item-center">
                                        <img src={start} className='mx-auto img-fluid' alt="" />
                                    </div>
                                    <div className="div star mx-1 d-flex align-item-center">
                                        <img src={start} className='mx-auto img-fluid' alt="" />
                                    </div>
                                    <div className="div star mx-1 d-flex align-item-center me-0">
                                        <img src={start} className='mx-auto img-fluid' alt="" />
                                    </div>

                                </div>
                            </div>
                            {/* <p className='my-0' style={{ fontSize: "14px", lineHeight: "40px", color: "#474d5cff" }}>Trust Score 5.0 | 3,724 reviews</p> */}
                        </div>
                    </div>

                </div>
                <div
                    className={`container-fluid mt-lg-0 animate-section ${animatedSections.has(4) ? 'visible' : ''}`}
                    ref={el => sectionRefs.current[4] = el}
                    data-section-index="4"
                >
                    <div className="row mx-auto card-bg-vect">
                        <div className="quote-symbol-container-first px-5 d-md-flex d-none" style={{ position: 'absolute', left: 0, top: "0px", zIndex: 0, }}>
                            <img src={card_vector} className="quote-symbol" alt="quote" />
                            <img src={card_vector} className="quote-symbol" alt="quote" />
                        </div>

                        <div
                            className="container-fluid mt-lg-5 animate-section"
                            ref={containerRef}
                            style={{ overflow: 'hidden', padding: '20px 0' }}
                        >
                            <div className="row mx-auto card-bg-vect" style={{ position: 'relative' }}>
                                <div
                                    className="d-flex"
                                    onMouseEnter={() => setIsAutoPlaying(false)}
                                    onMouseLeave={() => setIsAutoPlaying(true)}
                                    style={{
                                        transform: `translateX(-${currentIndex * CARD_WIDTH}px)`,
                                        transition: currentIndex >= testimonials.length ? 'none' : 'transform 0.5s ease-in-out',
                                        gap: '16px',
                                        willChange: 'transform',
                                    }}
                                >
                                    {infiniteTestimonials.map((testimonial, index) => (
                                        <Card
                                            key={`${testimonial.name}-${index}`}
                                            className="h-100 slide-card"
                                            style={{
                                                borderRadius: '20px',
                                                minWidth: `${CARD_WIDTH - 16}px`,
                                                maxWidth: `${CARD_WIDTH - 16}px`,
                                                flexShrink: 0,
                                                boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                                            }}
                                        >
                                            <Card.Body className="d-flex flex-column mt-md-4 mt-0 px-4">
                                                <h3 className="text-start m-0 card-heading text-dark">{testimonial.title}</h3>
                                                <Card.Text className="text-muted text-start insight-desc flex-grow-1">
                                                    {testimonial.quote}
                                                </Card.Text>
                                                <div className="d-flex align-items-center mt-3 mb-3">
                                                    <img
                                                        src={testimonial.img}
                                                        alt={testimonial.name}
                                                        className="rounded-5 me-3 card-user-img"
                                                        style={{ width: '50px', height: '50px', objectFit: 'cover' }}
                                                    />
                                                    <div className="text-start">
                                                        <h4 className="mb-0 text-dark m-0 card-user-name">{testimonial.name}</h4>
                                                        <span className="text-muted mb-0 card-rating">{testimonial.role}</span>
                                                    </div>
                                                    <div className="ms-auto mt-2 mx-0 align-items-center">
                                                        <div className="d-flex align-items-center">
                                                            <img
                                                                src={onestart}
                                                                alt="Star"
                                                                className="m-0"
                                                                style={{ width: '20px', height: '20px' }}
                                                            />
                                                            <span
                                                                className="ms-1 text-dark m-0"
                                                                style={{ fontWeight: '600', fontFamily: 'poppins', fontSize: '16px' }}
                                                            >
                                                                {testimonial.rating}
                                                            </span>
                                                        </div>
                                                        <span className="text-muted card-rating">Rating</span>
                                                    </div>
                                                </div>
                                            </Card.Body>
                                        </Card>
                                    ))}
                                </div>
                            </div>

                            <div className="container mt-lg-5 mt-4">
                                <div className="row mx-auto mb-lg-5 mb-3">
                                    <div className="d-flex col-lg-12 col-12 gap-2 align-items-center justify-content-center">
                                        <Button onClick={handlePrev} disabled={currentIndex === 0} className="btn fw-bold bg-white rounded-5 text-dark border-white shadow ">
                                            <i className="bi bi-arrow-left fw-bold"></i>
                                        </Button>
                                        <Button onClick={handleNext} disabled={currentIndex >= testimonials.length - visibleCards} className="btn bg-white text-dark border-white shadow fw-bold">
                                            <i className="bi bi-arrow-right"></i>
                                        </Button>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <section
                    className={`faq-section pb-md-5 pb-4 position-relative animate-section ${animatedSections.has(5) ? 'visible' : ''}`}
                    ref={el => sectionRefs.current[5] = el}
                    data-section-index="5"
                >
                    <div className="container border-top pt-md-5 pt-0">
                        <div className="row align-items-start pb-md-4  pt-md-4 pt-0 pb-0 mx-auto">
                            <div className="col-lg-5 my-0 d-flex align-items-center align-items-md-start justify-content-center  flex-column">

                                <div className="col-lg-12 m-0 col-12  mt-0  text-lg-start flex-column d-flex justify-content-center mb-md-4 mb-3">
                                    <h3 className='text-black contact-text  m-0 mt-lg-0 mt-4'>
                                        Frequently <span className='contact-text-orange' style={{ borderBottom: "4px solid" }}>Asked Question</span>

                                    </h3>
                                </div>
                                <p className="faq-subtitle text-md-start text-center">
                                    Get quick, reliable answers to your questions about our RCM
                                    solutions from processes and technology.
                                </p>
                                {/* <button
                                    onClick={handleShow}
                                    className="btn contact-btn d-flex align-items-center justify-content-center w-auto"
                                    style={{
                                        background: "linear-gradient(to right, #F37016 0%, #B1510F 100%)",
                                        color: "white",
                                        borderRadius: "12px",
                                        padding: "12px 24px",
                                        border: "none",
                                        fontWeight: "500",
                                        fontSize: "16px"
                                    }}
                                >
                                    Contact Us<i class="bi bi-arrow-right-short fs-3"></i>
                                </button> */}
                                <button className="btn contact-btn d-flex align-items-center justify-content-center w-auto " onClick={handleShow}>
                                    Contact Us<i class="bi bi-arrow-right-short fs-3"></i>
                                </button>
                            </div>

                            {/* Right Side */}
                            <div className="col-lg-7 ps-md-5">
                                <Accordion activeKey={activeKey} className='ps-md-5'>
                                    {[
                                        {
                                            q: "What is Probill RCM and how does it help healthcare providers?",
                                            a: "Probill RCM is an end-to-end revenue cycle management platform designed to streamline billing, coding, and collections ensuring faster payments and fewer denials for your practice."
                                        },
                                        {
                                            q: "Can Probill RCM integrate with our current EMR/EHR system?",
                                            a: "Yes, Probill RCM can integrate seamlessly with most EMR/EHR systems to ensure smooth workflows and secure data transfer."
                                        },
                                        {
                                            q: "How secure is Probill RCM with patient data?",
                                            a: "Probill RCM uses HIPAA-compliant infrastructure and advanced security protocols to safeguard patient data."
                                        },
                                        {
                                            q: "How long does it take to see results after implementation?",
                                            a: "Most practices start seeing improvements in revenue cycle performance within the first 30–60 days of implementation."
                                        }
                                    ].map((item, index) => (
                                        <Accordion.Item eventKey={String(index)} key={index} className='add_border_bottom'>
                                            <Accordion.Header
                                                onClick={() => toggleKey(String(index))}
                                                className="custom-header "
                                            >
                                                {item.q}
                                                <span className="icon">
                                                    {activeKey === String(index) ? (
                                                        <FaMinus />
                                                    ) : (
                                                        <FaPlus />
                                                    )}
                                                </span>
                                            </Accordion.Header>
                                            <Accordion.Body>{item.a}</Accordion.Body>
                                        </Accordion.Item>
                                    ))}
                                </Accordion>
                            </div>
                        </div>
                    </div>
                    <div class="boost_main_client boost_main_client_tranform position-absolute"><img src={clients} alt="" /></div>
                    <div class="boost_main_client_right boost_main_client_right_tranform position-absolute"><img src={workright} alt="" /></div>
                </section>
                <section
                    className={`pb-md-5 pb-4 rcm-section step-bg-img animate-section ${animatedSections.has(6) ? 'visible' : ''}`}
                    ref={el => sectionRefs.current[6] = el}
                    data-section-index="6"
                >
                    <Container className='pb-md-4 pb-0'>
                        <div class="bg_img_Add">
                            <div class="container">
                                <div class="row">
                                    <div class="col-md-12 col-12 ">
                                        <div class="row mx-auto"><div class="col-md-9 col-12">
                                            <h2 class="mb-0 fw-semibold text-white add_font_bg_section text-center text-md-start fs-2">Looking to learn more about us? It all starts here. </h2>
                                        </div>
                                            <div className=" col-md-3 col-12 mt-3 mt-md-0 d-flex justify-content-center justify-content-md-end add_btn_format_circle_hover">

                                                <button
                                                    className="btn d-flex align-items-center justify-content-center add_padding_font"
                                                    onClick={handleShow} type="button"
                                                    style={{
                                                        background: "linear-gradient(to right, #F37016 0%, #B1510F 100%)",
                                                        color: "white",
                                                        borderRadius: "12px",
                                                        padding: "4px 24px",
                                                        border: "none",
                                                        fontWeight: "500",
                                                        fontSize: "16px",
                                                        // boxShadow: "0 2px 8px rgba(233, 114, 14, 0.3)"
                                                    }}
                                                >
                                                    Talk to an expert<i class="bi bi-arrow-right-short fs-3"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Container>
                </section>
                <Modal show={showModal} onHide={handleClose} centered size='xl'>
                    {/* Close Button in Top-Right Corner */}
                    <button
                        type="button"
                        className="btn-close position-absolute"
                        style={{
                            top: "11px",
                            right: "11px",
                            zIndex: 1051,
                            backgroundColor: "#fff",
                            borderRadius: "50%",
                            padding: "6px",
                            fontSize: "15px",
                            // border: "2px solid black",
                        }}
                        aria-label="Close"
                        onClick={handleClose}
                    ></button>

                    <Modal.Body className="p-4">
                        <div className="container-fluid">
                            <div className="row d-flex justify-content-center align-items-center">
                                <div className="col-lg-6 d-none d-lg-block">
                                    <div className="image-container">
                                        <img
                                            src={external1}
                                            alt="Team Working"
                                            className="w-100 h-100 diagonal-image"
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-12 ps-md-4 ps-0">
                                    {isSubmitted ? (
                                        <div className="text-center">
                                            <h1 className="hero-text mt-0">
                                                Thank <span className="text-orange add_grident_font" style={{ color: "#E9720E" }}>You!</span> <br />
                                            </h1>
                                            <p>for submitting your information! Our representative will reach out to you shortly.</p>
                                        </div>
                                    ) : (
                                        <>
                                            <div className="d-flex m-0 modal-heading justify-content-between">
                                                <h1>
                                                    How can we <span style={{ color: "#E27239" }}>help you?</span>
                                                </h1>
                                                {/* Remove this old close button if not needed */}
                                                {/* <button
                                                   type="button"
                                                   className="btn-close d-lg-none d-block"
                                                   onClick={handleClose}
                                                   data-bs-dismiss="modal"
                                                   aria-label="Close"
                                               ></button> */}
                                            </div>
                                            <p className="fs-6 m-0 d-lg-none" style={{ color: "#2A3040" }}>
                                                Within 24 hours, a representative from our company will contact you.
                                            </p>
                                            <form onSubmit={handleSubmit(onSubmit)} className="mt-0">
                                                <div className="row">
                                                    <div className="col-md-6 mb-3">
                                                        <label className="form-label fw-medium text-start d-block">Name</label>
                                                        <input
                                                            type="text"
                                                            placeholder="Enter your Full Name"
                                                            className={`custom_control py-2 form-control ${errors.fullName ? "is-invalid" : ""}`}
                                                            style={{ border: "1px solid #A4A4A480", height: "48px" }}
                                                            {...register("fullName", { required: "Full Name is required" })}
                                                        />
                                                        {errors.fullName && (
                                                            <p className="text-danger">{errors.fullName.message}</p>
                                                        )}
                                                    </div>

                                                    <div className="col-md-6 mb-3">
                                                        <label className="form-label fw-medium text-start d-block">Email</label>
                                                        <input
                                                            type="email"
                                                            placeholder="Enter your Email"
                                                            className={`custom_control py-2 form-control ${errors.email ? "is-invalid" : ""}`}
                                                            style={{ border: "1px solid #A4A4A480", height: "48px" }}
                                                            {...register("email", {
                                                                required: "Email is required",
                                                                pattern: {
                                                                    value: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
                                                                    message: "Please enter a valid email address"
                                                                }
                                                            })}
                                                        />
                                                        {errors.email && (
                                                            <p className="text-danger">{errors.email.message}</p>
                                                        )}
                                                    </div>

                                                    <div className="col-md-12 mb-3">
                                                        <label className="form-label fw-medium text-start d-block">Subject</label>
                                                        <input
                                                            type="text"
                                                            placeholder="Enter Subject"
                                                            className={`custom_control py-2 form-control ${errors.subject ? "is-invalid" : ""}`}
                                                            style={{ border: "1px solid #A4A4A480", height: "48px" }}
                                                            {...register("subject", {
                                                                required: "Subject is required",
                                                                minLength: {
                                                                    value: 3,
                                                                    message: "Subject should be at least 3 characters long"
                                                                }
                                                            })}
                                                        />
                                                        {errors.subject && (
                                                            <p className="text-danger">{errors.subject.message}</p>
                                                        )}
                                                    </div>

                                                    <div className="col-md-12 mb-3">
                                                        <label className="form-label fw-medium text-start d-block">Message</label>
                                                        <textarea
                                                            className={`custom_control py-2 form-control ${errors.message ? "is-invalid" : ""}`}
                                                            style={{ border: "1px solid #A4A4A480" }}
                                                            rows="7"
                                                            placeholder="Brief us on your requirements"
                                                            {...register("message", {
                                                                required: "Message is required",
                                                                minLength: {
                                                                    value: 10,
                                                                    message: "Message should be at least 10 characters long"
                                                                }
                                                            })}
                                                        ></textarea>
                                                        {errors.message && (
                                                            <p className="text-danger">{errors.message.message}</p>
                                                        )}
                                                    </div>

                                                    <div className="col-md-12 mt-3">
                                                        <button
                                                            type="submit"
                                                            className="btn col-12"
                                                            style={{
                                                                background: "linear-gradient(to right, #F37016 0%, #B1510F 100%)",
                                                                color: "white",
                                                                borderRadius: "12px",
                                                                padding: "12px 24px",
                                                                border: "none",
                                                                fontWeight: "500",
                                                                fontSize: "16px"
                                                            }}
                                                            disabled={isSubmitting}
                                                        >
                                                            {isSubmitting ? "SENDING..." : "Submit Now"}
                                                        </button>
                                                    </div>
                                                </div>
                                            </form>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    </Modal.Body>

                </Modal>
            </section>
        </>
    );
}
export default ContactUs;
